import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

/*
* Loding
*/
$(window).bind("load", function() {
   $('header.page-header').find('nav').addClass('loaded');
});

$(document).foundation();

/**** Script *****/

/*
* Slider
*/
var inWrap = $('.slide-wrap');

function slideNext() {
	$('.slide').eq(1).find('.lead-message').children().each(function() {
		$(this).removeClass('show');
	});

	inWrap.animate({left: '-200%'}, 300, function() {
		// Slide
		inWrap.css('left', '-100%');
		// Change slide
		$('.slide').last().after($('.slide').first());
	});  

	setTimeout(addClassNameImg1, 1000);
	setTimeout(addClassNameImg2, 1500);
	setTimeout(addClassNameText, 2000);
}

function addClassNameImg1() {
	$('.slide').eq(1).find('.lead-message > img:eq(0)').addClass('show');
}

function addClassNameImg2() {
	$('.slide').eq(1).find('.lead-message > img:eq(1)').addClass('show');
}

function addClassNameText() {
	$('.slide').eq(1).find('.lead-message > div').addClass('show');
}

// Display slide
setTimeout(addClassNameImg1, 1000);
setTimeout(addClassNameImg2, 1500);
setTimeout(addClassNameText, 2000);

// Auto scroll
setInterval(slideNext, 5000);


/*
* Global Navi
*/
// ハンバーガーボタン
$('.humberger-icon').click(function(){
	$(this).toggleClass('open');
	$('header.page-header').toggleClass('menu-open');
});

// entry buttonクリック後にメニューが開いていたら閉じる
$('#entry-button').click(function(){
	var page_heaer = $('header.page-header');
	if( page_heaer.hasClass('menu-open') ) {
		page_heaer.find('nav.loaded').hide();
		$('.humberger-icon').toggleClass('open');
		page_heaer.toggleClass('menu-open');
	}
});

/*
* Smooth Scroll
*/
$('a[href^="#"]').click(function(){
	var speed = 500;
	var href= $(this).attr("href");
	var target = $(href == "#" || href == "" ? 'html' : href);
	var position = target.offset().top;
	$("html, body").animate({scrollTop:position}, speed, "swing");
	return false;
});

/*
* トップページのScrollをスクロール後に非表示にする
*/
$(window).scroll(function(){
	var scr_count = $(document).scrollTop();
	var scrolled = 400;
	if ( scr_count > scrolled) {
		$('.scroll').addClass('scrolled');
	} else {
		$('.scroll').removeClass('scrolled');
	}
});

/*
* グローバルメニューの子要素がある親リンクはクリックを無効
*/
$('ul.menu').find('a.disabled').each(function(){
	$(this).click(function(e){
		e.preventDefault();
	})
});

/*
* back-to-top ボタン
*/
$(window).scroll(function () {
	if ($(this).scrollTop() > 300) {
		$('#back-to-top').fadeIn();
	} else {
		$('#back-to-top').fadeOut();
	}
});

$('#back-to-top a').click(function() {
	$('body,html').animate({
		scrollTop: 0
	}, 800);
	return false;
});

/*
* Trigger CSS animations on scroll.
* Copyright (c) bramus(@bramus)
* https://codepen.io/bramus/pen/yikfd
* Released under the MIT license
* http://opensource.org/licenses/mit-license.php
*/
var doAnimations = function() {
	// 現在のoffsetを計算してすべてのanimateを取得する
	var offset = $(window).scrollTop() + $(window).height(),
	$animatables = $('.animatable');

    // animationするものがなければscrollハンドラを削除
	if ($animatables.length == 0) {
		$(window).off('scroll', doAnimations);
	}

	// animation処理
	$animatables.each(function(i) {
		var $animatable = $(this);
		if (($animatable.offset().top + $animatable.height() - 20) < offset) {
			$animatable.removeClass('animatable').addClass('animated');
		}
	});
};
  
// スクロールに合わせてdoAnimations関数を実行
$(window).on('scroll', doAnimations);
$(window).trigger('scroll');
